// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const RepairIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="RepairIcon" ref={forwardedRef} {...props}>
      <path d="M11.833 2.056c1.038-.175 2.138.041 2.998.902l.53.53-2.396 2.397 1.08 1.08 2.362-2.362.53.53C17.804 6 18.033 7.098 17.865 8.14c-.164 1.02-.706 2.002-1.41 2.77-.702.768-1.623 1.387-2.612 1.61-.797.178-1.634.093-2.377-.368L6.39 17.433a2.25 2.25 0 0 1-3.214.032L2.659 16.95a2.25 2.25 0 0 1-.032-3.15l5.138-5.344C7.304 7.71 7.228 6.87 7.42 6.074c.236-.98.866-1.897 1.639-2.598.774-.702 1.757-1.248 2.774-1.42m1.29 1.55a2.05 2.05 0 0 0-1.04-.07c-.677.114-1.406.498-2.017 1.052C9.455 5.143 9.028 5.81 8.88 6.425c-.14.584-.035 1.108.406 1.55l.52.52-.509.53-5.587 5.813a.75.75 0 0 0 .01 1.05l.518.517a.75.75 0 0 0 1.07-.01l5.546-5.77.53-.553.541.54c.462.463 1.004.576 1.59.444.618-.138 1.282-.556 1.833-1.158.55-.6.928-1.323 1.037-1.997a2.05 2.05 0 0 0-.089-1.063l-2.25 2.249-3.202-3.202z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const RepairIcon = /* @__PURE__ */ Object.assign(RepairIconComponent, {
  displayName: 'RepairIcon',
});
